import HexButton from './src/index.vue'

HexButton.install = function (Vue) {
  Vue.component(HexButton.name, HexButton)
}
export default HexButton



// WEBPACK FOOTER //
// ./packages/components/button/index.js